<template>
  <div class="content">
    <h1 class="has-text-centered">Digitale Signatur</h1>
    <div class="box">
      <p>Eine kompakte Zusammenfassung über digitale Signaturen.</p>
      <FAQsTableOfContents :faqs="faqs" />
    </div>

    <div class="box">
      <FAQs :faqs="faqs" :h_level="2" />
    </div>

    <FeedbackBox />
  </div>
</template>

<script>
import FeedbackBox from '@/components/FeedbackBox.vue'
import FAQs from '@/components/FAQs.vue'
import FAQsTableOfContents from '@/components/FAQsTableOfContents.vue'

export default {
  name: 'theory-digital-signature',
  components: {
    FeedbackBox,
    FAQs,
    FAQsTableOfContents
  },
  metaInfo: {
    title: 'Digitale Signatur | Elektrotechnik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Eine kompakte Zusammenfassung über digitale Signaturen.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'network-engineering' })
  },
  data () {
    return {
      faqs: [
        {
          question: 'Was ist eine digitale Signatur?',
          answer:
            '<ul>' +
            '  <li>Eine schlüsselabhängige Prüfsumme die von einem Dokument oder einer Nachricht in Kombination mit einem Schlüssel erzeugt wird</li>' +
            '  <li>Werden verwendet um &nbsp;die Echtheit von Dokumenten und Nachrichten prüfbar zu machen</li>' +
            '  <li>Sobald ein Dokument oder eine Nachricht verändert wird, muss eine neue Prüfsumme erstellt werden</li>' +
            '  <li>Für digitale Signaturen gelten folgende Anforderungen:</li>' +
            '  <ul>' +
            '    <li>Das signierte Dokument darf nicht (unbemerkt) veränderbar sein</li>' +
            '    <li>Die Echtheit der digitalen Signatur muss überprüfbar sein</li>' +
            '    <li>Die digitale Signatur darf nicht (unbemerkt) fälschbar sein</li>' +
            '    <li>Die digitale Signatur darf nicht von einem Dokument auf ein anderes (unbemerkt) übertragbar sein</li>' +
            '  </ul>' +
            '  <li>Anwendung</li>' +
            '  <ul>' +
            '    <li>Als Handy-Signatur ermöglicht es Rechnungen und Dokumente rechtsgültig elektronisch zu unterschreiben und erspart zeitintensive Behördengänge</li>' +
            '    <li>Dokumente sind vor ungewollten Änderungen geschützt</li>' +
            '  </ul>' +
            '</ul>'
        },
        {
          question: 'Wie funktionieren digitale Signaturen?',
          answer:
            '<ul>' +
            '  <li>Basiert auf der asymmetrischen Kryptographie (ein öffentlicher und ein privater Schlüssel)</li>' +
            '  <ul>' +
            '    <li>Daten werden mit dem (geheimen) privaten Schlüssel verschlüsselt und können nur mehr mit dem öffentlichen Schlüssel entschlüsselt werden</li>' +
            '  </ul>' +
            '  <li>Die Verschlüsselung wird mittels privaten Schlüssel wird auf einen Hash-Wert der Daten angewendet</li>' +
            '  <li>Die verwendete Hashfunktion muss kollisionsresistent sein - das bedeutet es muss praktisch unmöglich sein, zwei unterschiedliche Nachrichten/Dokumente zu finden, deren Hash-Wert identisch ist</li>' +
            '  <li>Ablauf</li>' +
            '  <ol>' +
            '    <li>Hash-Wert der Nachricht beziehungsweise des Dokuments wird erstellt ("Fingerprint")</li>' +
            '    <li>Der Hash-Wert wird mit dem privaten Schlüssel verschlüsselt</li>' +
            '    <li>Das Dokument beziehungsweise die Nachricht wird als Einheit mit dem verschlüsselten Hash-Wert übertragen</li>' +
            '    <li>Der Empfänger nutzt den öffentlichen Schlüssel zu Entschlüsselung und gleicht den Hash-Wert mit dem Dokument ab</li>' +
            '  </ol>' +
            '</ul>'
        },
        {
          question: 'Was ist ein Signaturverfahren?',
          answer:
            '<ul>' +
            '  <li>Es gibt verschiedene Signaturverfahren</li>' +
            '  <li>Das meistgenutzte Signaturverfahren ist RSA</li>' +
            '  <ul>' +
            '    <li>RSA = <strong>R</strong>ivest, <strong>S</strong>hamir und <strong>A</strong>dleman</li>' +
            '    <li>Arbeitet deterministisch und ist daher anfällig für Angriffe - daher wird RSA mit dem Optimal Asymmetric Encryption Padding kombiniert</li>' +
            '    <li>Ist mit Rabin-Verschlüsselungsverfahren verwandt</li>' +
            '  </ul>' +
            '</ul>'
        }
      ]
    }
  }
}
</script>
